module.exports = "data:image/webp;base64,UklGRhYBAABXRUJQVlA4WAoAAAAQAAAADwAADwAAQUxQSH4AAAABYFJre5bnHNw8CT65BjioQQY6LMA0mhrUWI0VmHsEPxkiYgJ4Tb0nPqc9WHUl9ulxWd+qF1Ds8RbdQmjwRmgUC18USzMDm25AtukELLoAkzoenCePYTMe72GrHn8Oa3bMX/MwU23pLTUrcDuOBOkY3jxPtXf15D1fXfuVAQBWUDggcgAAAFAEAJ0BKhAAEAABQCYlsAJ0ugH4AOYBoQHmAewB+gHAAftn6gH9j//4SyAA/uC5f/OL5s8F/HV8+xsOOBSlwuejab+sXkjfsenccN/fFfDAYK7/9NLIqhCr93wxTHEffVh9jP3+tEQSfROBsQhbmfgAAA=="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/icon_power.webp
// module id = tpyp
// module chunks = 3